import { createAction } from '@reduxjs/toolkit'

import { curryActionForPage, curryActionForResource } from 'helpers/curry'
import { ActionForPagePayload, ActionForResourcePayload } from 'types'

// Fetch
export const fetchResourceSuccess = createAction<ActionForPagePayload<unknown>>(
    'FETCH_RESOURCE_SUCCESS'
)
export const makeFetchResourceSuccess = curryActionForPage(fetchResourceSuccess)

// Update
export const updateResourceRequest = createAction<
    ActionForResourcePayload<unknown>
>('UPDATE_RESOURCE_REQUEST')
export const updateResourceSuccess = createAction<
    ActionForResourcePayload<unknown>
>('UPDATE_RESOURCE_SUCCESS')
export const updateResourceFailure = createAction<
    ActionForResourcePayload<{ message: string }>
>('UPDATE_RESOURCE_FAILURE')

export const makeUpdateResourceRequest = curryActionForResource(
    updateResourceRequest
)
export const makeUpdateResourceSuccess = curryActionForResource(
    updateResourceSuccess
)
